/* eslint-disable max-lines */
import {
    ShelvesGoodsItemQuery,
    PartnerSpuAddDTO,
    AddDrpGoodsResult,
    ErpGoodsToDrpParam,
    ErpSupplySalesGoodsFavoriteParam,
    SummaryShelvesItemCategoryResult,
    QuerySpuIdByPartnerSpuIdUsingGetParams,
    SimpleItemInfo,
    QueryChannelPartnerOnlineSkuVo,
    ChannelPartnerSkuVo,
    ShopSkuDownloadUsingGetParams,
    QueryOnlineSkuParam,
    ExhibitionShopSku,
    DrpSkuCountVo,
    UpdateSyncStockForSpu,
    UpdateSyncStockForSku,
    BooleanResult,
    QuerySkuStockParam,
    QuerySkuStockResult,
    StyleCodeCheckVo,
    StyleCodeCheckResult,
    DisGoodsErpStatusVo,
    ExcelTipsInfo,
    DisGoodsImportParam,
    GetCheckNeedUpdateUsingGetParams,
    GoChannelPartnerSpu,
    ChannelPartnerSkuQueryVo,
    ChannelPartnerSkuResult,
    DistributionDrpLimitVo,
    OrderAddDrpRuleVo,
    ErpGoodsQuerySkuParam,
    DrpGoodsSkuStatusVo,
    ChannelPartnerSpuVo,
    ShopSpuQueryParam,
    BaseShopSpuVo,
    ShopSkuQueryParam,
    BaseShopSkuVo,
    PromoteNewItemVo,
    CoIdAndSpuId,
    OperateGoodsPrice,
} from '@servicesTypings/goodsRequest'
import { goodsRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

import { BatchUpdateSyncStock } from '@servicesTypings/goodsRequestV3'

/**
 * 查询分销商品列表
 */
export function queryTable(data: ShelvesGoodsItemQuery): API.Res<object> {
    return goodsRequest.post('/buyer/partnerSpu/queryChannelPartnerSpuList', { data })
}

/**
 * 添加供销商品
 */
export function addParterSpuApi(data: PartnerSpuAddDTO): API.Res<AddDrpGoodsResult> {
    return goodsRequest.post('/buyer/partnerSpu/add', { data })
}

/**
 * 全部页全选添加供销商品
 */
export function addByConditionApi(data: ErpGoodsToDrpParam): API.Res<string> {
    return goodsRequest.post('/buyer/partnerSpu/addByCondition', { data })
}

// 加入分销商品 在收藏页面   单页
/**
 * 加入分销商品
 */
export function addPartnerSpuApiInFavPage(data: PartnerSpuAddDTO): API.Res<AddDrpGoodsResult> {
    return goodsRequest.post('/channel/erpSupplySalesGoodsFavorite/addPartnerSpu', { data })
}

// 加入分销商品 在收藏页面   全部页
/**
 * 全部页全选添加供销商品
 */
export function addByConditionApiInFavPage(data: ErpSupplySalesGoodsFavoriteParam): API.Res<string> {
    return goodsRequest.post('/channel/erpSupplySalesGoodsFavorite/addByCondition', { data })
}

/**
 * 汇总已铺货商品的类目列表
 */
export function queryCategoryListApi(): API.Res<SummaryShelvesItemCategoryResult[]> {
    return goodsRequest.get('/buyer/gylItemShelvesInfo/summaryShelvesItemCategoryList')
}

/**
 * deleteByIds
 */
export function removeGoods(data: string[]): API.Res<boolean> {
    return goodsRequest.post('/buyer/partnerSpu/delete', { data })
}

/**
 * 全部页删除分销商品
 */
export function removeAllGoods(data: ShelvesGoodsItemQuery): API.Res<string> {
    return goodsRequest.post('/buyer/partnerSpu/deleteByCondition', { data })
}

/**
 * 根据分销商品ID获取商品ID
 */
export function getGoodsBaseDataId(params: QuerySpuIdByPartnerSpuIdUsingGetParams): API.Res<SimpleItemInfo> {
    return goodsRequest.get('/goChannelPartnerSpu/querySpuIdByPartnerSpuId', { params })
}

/**
 * 查看线上关联商品
 */
export function getChannelPartnerSkuList(data: QueryChannelPartnerOnlineSkuVo): API.Res<ChannelPartnerSkuVo[]> {
    return goodsRequest.post('/goChannelPartnerSku/list', { data })
}

/**
 * 下载店铺商品资料
 */
export function getSpuShopSkuDownload(params: ShopSkuDownloadUsingGetParams): API.Res<string> {
    return goodsRequest.get('/goChannelPartnerSpu/shopSkuDownload', { params })
}

export function getIsBindShopApi() {
    return goodsRequest.get('/buyer/partnerSpu/checkShopBind')
}

/**
 * 查看线上关联商品
 */
/**
 * 查看线上关联商品
 */
export function querySkuByItemCode(data: QueryOnlineSkuParam): API.Res<ExhibitionShopSku[]> {
    return goodsRequest.post('/buyer/gylItemShelvesInfo/querySkuByItemCode', { data })
}

/**
 * 查看关联商品sku是否同步
 */
/**
 * 查看线上关联商品-按sku
 */
export function querySkuByPartnerSkuId(data: DrpSkuCountVo): API.Res<ChannelPartnerSkuVo[]> {
    return goodsRequest.post('/goChannelPartnerSku/querySkuByPartnerSkuId', { data })
}

/**
 * 批量修改库存同步
 */
/**
 * 批量修改库存同步
 */
export function changeSyncStock(data: UpdateSyncStockForSpu): API.Res<object> {
    return goodsRequest.post('/goChannelPartnerSku/changeSyncStock', { data })
}

/**
 * 批量修改库存同步(SKU)
 */
/**
 * 批量修改SKU库存同步
 */
export function changeSyncStockForSku(data: UpdateSyncStockForSku): API.Res<object> {
    return goodsRequest.post('/goChannelPartnerSku/changeSyncStockForSku', { data })
}

/**
 * 用户是否库存同步开关白名单
 */
/**
 * 用户是否库存同步开关白名单
 */
export function queryChangeStockWhiteList(): API.Res<BooleanResult> {
    return goodsRequest.get('/goChannelPartnerSku/queryChangeStockWhiteList')
}

/**
 *
 * 查询供应商商品(sku维度)的库存
 */
/**
 * 查询供应商商品(sku维度)的库存
 */
export function querySupplierSkuStock(data: QuerySkuStockParam): API.Res<QuerySkuStockResult[]> {
    return goodsRequest.post('/goodsManage/shopSku/querySupplierSkuStock', { data })
}

/**
 * @description:  校验选中款式编码是否存在重复 【供应测分销商品】
 */
/**
 * 校验选中款式编码是否存在重复
 */
export function checkDrpSelectStyleCode(data: StyleCodeCheckVo): API.Res<StyleCodeCheckResult> {
    return goodsRequest.post('/goChannelPartnerSpu/checkDrpSelectStyleCode', { data })
}

/**
 * @description:   查询选中商品是否存在于ERP 【供应测分销商品】
 */
/**
 * 查询选中商品是否存在于ERP
 */
export function checkDistributionItemErpStatus(data: DisGoodsErpStatusVo): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/goChannelPartnerSpu/checkItemErpStatus', { data })
}

/**
 * @description:   分销商品批量转二级分销 【供应测分销商品】
 */
/**
 * 分销商品批量转二级分销
 */
export function batchImportDisGoods(data: DisGoodsImportParam): API.Res<string> {
    return goodsRequest.post('/goChannelPartnerSpu/importDisGoods', { data })
}

/**
 * 检查分销商品编辑是否需要提示更新导入
 */
/**
 * 检查分销商品编辑是否需要提示更新导入
 */
export function getCheckNeedUpdate(params: GetCheckNeedUpdateUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/buyer/partnerSpu/getCheckNeedUpdate', { params })
}

/**
 * 更新分销商品编辑提示更新状态位
 */
/**
 * 更新分销商品编辑提示更新状态位
 */
export function updateCheckNeedUpdate(data: GoChannelPartnerSpu): API.Res<object> {
    return goodsRequest.post('/buyer/partnerSpu/updateCheckNeedUpdate', { data })
}

/**
 * 分销商品SKU列表
 */
/**
 * 查询分销商品sku列表
 */
export function queryTableSKU(data: ChannelPartnerSkuQueryVo): API.Res<ChannelPartnerSkuResult[]> {
    return goodsRequest.post('/goChannelPartnerSku/queryChannelPartnerSkuList', { data })
}

/**
 * 分销商品-查询7天内变价商品个数
 */
/**
 * 查询7天内变价商品个数
 */
export function querySevenDayDrpGoodChangePriceCount(): API.Res<number> {
    return goodsRequest.get('/buyer/partnerSpu/querySevenDayDrpGoodChangePriceCount')
}

/**
 * 判断是否超过分销商品一件代发数量限制
 */
/**
 * 判断是否超过分销商品一件代发数量限制
 */
export function checkOverDistributionDrpLimit(data: string[]): API.Res<DistributionDrpLimitVo> {
    return goodsRequest.post('/buyer/partnerSpu/checkOverDistributionDrpLimit', { data })
}

// 批量加入分销商品
/**
 * 批量将商品直接加入分销判断策略
 */
export function batchAddDrpRuleApi(data: OrderAddDrpRuleVo[]): API.Res<boolean> {
    return goodsRequest.post('/buyer/partnerSpu/orderDrpSku/addDrpRuleBatch', { data })
}

/**
 *查询款纬度的ERP相关字段信息
 */
/**
 * 查询SKU纬度的ERP相关字段信息
 */
export function queryErpInfoForSku(data: ErpGoodsQuerySkuParam): API.Res<DrpGoodsSkuStatusVo[]> {
    return goodsRequest.post('/goodslist/erp/queryErpInfoForSku', { data })
}

/**
 * 清空无效分销商品
 */
/**
 * 清理无效分销商品
 */
export function cleanInvalidDistributionSpu(): API.Res<string> {
    return goodsRequest.get('/buyer/partnerSpu/cleanInvalidDistributionSpu')
}

/**
 * 查询分销商品列表
 */
/**
 * 查询分销商品列表
 */
export function queryChannelPartnerSpuErpField(data: string[]): API.Res<ChannelPartnerSpuVo[]> {
    return goodsRequest.post('/buyer/partnerSpu/queryChannelPartnerSpuErpField', { data })
}

/**
 * 查询批量更新线上商品商品列表-款维度
 */
/**
 * 查询批量更新线上商品商品列表-款维度
 */
export function queryShopSpuList(data: ShopSpuQueryParam): API.Res<BaseShopSpuVo[]> {
    return goodsRequest.post('/shopItem/queryShopSpuList', { data })
}

// 查询批量更新线上商品商品列表-sku维度
/**
 * 查询批量更新线上商品商品列表-sku维度
 */
export function queryShopSkuList(data: ShopSkuQueryParam): API.Res<BaseShopSkuVo[]> {
    return goodsRequest.post('/shopItem/queryShopSkuList', { data })
}

// 分销商品查询已下架数量
export function queryDrpItemNotify(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/buyer/partnerSpu/drpItemNotify', {
        params,
    })
}

// 分销商品查询已下架数量
export function queryDrpItemNotifyWithCache(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/buyer/partnerSpu/drpItemNotifyWithCache', {
        params,
    })
}

// 查询7天供应商分销控价变动商品数量
export function querySupplierRegulatePriceChangeNum(params) {
    const goodsRequestCache = getCacheService(goodsRequest)
    return goodsRequestCache.get('/buyer/partnerSpu/querySupplierRegulatePriceChangeNum', {
        params,
    })
}

// 查询运营推荐的商品(大店商品)
/**
 * 查询运营推荐的商品
 */
export function queryOperateFreshmanGoods(): API.Res<PromoteNewItemVo[]> {
    return goodsRequest.get('/freshman/mall/operateGoods')
}

/**
 * 查询运营推荐的商品的价格
 */
/**
 * 查询运营推荐的商品的价格
 */
export function queryOperateFreshmanGoodsPrice(data: CoIdAndSpuId[]): API.Res<OperateGoodsPrice[]> {
    return goodsRequest.post('/freshman/mall/operateGoodsPrice', { data })
}

/**
 * 批量修改库存同步
 */
export function batchChangeSyncStock(data: BatchUpdateSyncStock): API.Res<string> {
    return goodsRequest.post('/goChannelPartnerSku/batchChangeSyncStock', { data })
}
